// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".richText-module_richtext_aoRTzvI9Jgn8kRhLmolA{font-size:16px;line-height:22px}", "",{"version":3,"sources":["webpack://./src/bloks/articlepanels/richText/richText.module.scss"],"names":[],"mappings":"AACA,+CACE,cAAA,CACA,gBAAA","sourcesContent":["@import \"src/styles/theme.scss\";@import \"~cx-web-themes/crunchyroll/abstracts/main\";\n.richtext {\n  font-size: 16px;\n  line-height: 22px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"richtext": "richText-module_richtext_aoRTzvI9Jgn8kRhLmolA"
};
export default ___CSS_LOADER_EXPORT___;
